import { Component, Input, OnInit } from '@angular/core';

import { isMotivoPerdaVendaAtivo, isMotivoPerdaVendaInativo } from '../motivo-perda-venda-situacao';

interface Config {
    isAtivo: boolean;
    isInativo: boolean;
}

@Component({
    selector: 'sgt-motivo-perda-venda-situacao-badge',
    templateUrl: './motivo-perda-venda-situacao-badge.component.html',
    styleUrls: ['./motivo-perda-venda-situacao-badge.component.less']
})
export class MotivoPerdaVendaSituacaoBadgeComponent implements OnInit {
    config: Config;

    /** Situação do motivo da perda */
    @Input() situacao: number;
    /** Tamanho da font */
    @Input() fontSize = '8px';

    ngOnInit(): void {
        this.setConfig();
    }

    private setConfig() {
        this.config = {
            isAtivo: isMotivoPerdaVendaAtivo(this.situacao),
            isInativo: isMotivoPerdaVendaInativo(this.situacao)
        }
    }
}
